import MaskService from "./mask/maskService";

const formatToValue = (value, decimalPlaces = 2) => {
  value = value || 0;
  return (
    (value < 0 ? "-" : "") +
    MaskService.toMask("decimal", parseFloat(value || 0).toFixed(decimalPlaces))
  );
};

const roundLargeNumbers = (value) => {
  const formatedValue =
    typeof value === "number" ? formatToValue(value) : value;

  if (
    !isNaN(
      (formatedValue ?? "").toString().replaceAll(".", "").replaceAll(",", ".")
    )
  ) {
    const splitedValue = formatedValue.split(".");
    const thousandCount = splitedValue.length - 1;

    if (thousandCount > 0) {
      if (splitedValue[1][0] === "0") {
        return `${splitedValue[0]}${"K".repeat(thousandCount)}`;
      } else {
        return `${splitedValue[0]},${splitedValue[1].slice(0, 2)}${"K".repeat(
          thousandCount
        )}`;
      }
    }
  }

  return formatedValue;
};

export { formatToValue, roundLargeNumbers };
